import { NavigationItemInterface } from './navigation-item.interface';
import { UserRole } from '../../../common/models/user/user-role.enum';

const allExceptUnpaidUserAndAdmin = [
  UserRole.ROLE_PERSONAL,
  UserRole.ROLE_BUSINESS,
  UserRole.ROLE_BUSINESS_EXP,
  UserRole.ROLE_BUSINESS_PLUS_EXP,
  UserRole.ROLE_BUSINESS_PLUS,
];

const baseCustomerRoute = '/customer';
const baseAdminRoute = '/admin';
export const navigationItems: NavigationItemInterface[] = [
  {
    route: '/home',
    nameKey: 'home',
    visibleForNotLoggedIn: true,
  },
  {
    route: '/home-calculator',
    nameKey: 'home-calculator',
    visibleForNotLoggedIn: true,
  },
  {
    route: '/pricing',
    nameKey: 'pricing',
    visibleForNotLoggedIn: true,
  },
  {
    route: '/contact-us',
    nameKey: 'contact_us',
    visibleForNotLoggedIn: true,
  },
  {
    route: `${ baseCustomerRoute }/advanced-calculator`,
    nameKey: 'advanced-calculator',
    roles: allExceptUnpaidUserAndAdmin,
  },
  {
    route: `${ baseCustomerRoute }/saved-power-plants`,
    nameKey: 'saved-power-plants',
    roles: allExceptUnpaidUserAndAdmin,
  },
  {
    route: `${ baseCustomerRoute }/offer-requests`,
    nameKey: 'offer-requests',
    roles: [
      UserRole.ROLE_BUSINESS_PLUS,
    ],
  },
  {
    route: `${ baseCustomerRoute }/my-prices`,
    nameKey: 'my-prices',
    roles: allExceptUnpaidUserAndAdmin,
  },
  {
    route: `${ baseCustomerRoute }/business-dashboard`,
    nameKey: 'business-dashboard',
    roles: [
      UserRole.ROLE_BUSINESS_PLUS,
      UserRole.ROLE_BUSINESS_PLUS_EXP,
    ],
  },
  {
    route: `${ baseAdminRoute }/dashboard`,
    nameKey: 'dashboard',
    roles: [
      UserRole.ROLE_ADMIN,
    ],
  },
  {
    route: `${ baseAdminRoute }/users`,
    nameKey: 'users',
    roles: [
      UserRole.ROLE_ADMIN,
    ],
  },
  {
    route: `${ baseAdminRoute }/parameters`,
    nameKey: 'parameters',
    roles: [
      UserRole.ROLE_ADMIN,
    ],
  },
  {
    route: `${ baseAdminRoute }/public-prices`,
    nameKey: 'public-prices',
    roles: [
      UserRole.ROLE_ADMIN,
    ],
  },
  {
    route: `${ baseAdminRoute }/banks`,
    nameKey: 'banks',
    roles: [
      UserRole.ROLE_ADMIN,
    ],
  },
];
